export const CONTRACTOR = 'CONTRACTOR';
export const UPDATE_CONTRACTOR = 'UPDATE_CONTRACTOR';
export const CLEAR_CONTRACTOR = 'CLEAR_CONTRACTOR';
export const LOAD_PAGES = 'LOAD_PAGES';
export const SET_SELECTED_PAGE = 'SET_SELECTED_PAGE';
export const LOAD_W9 = 'LOAD_W9';
